import React from 'react'

function TrafficIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.46704 9.5332C11.2803 10.0633 17.0669 11.8683 20.5032 12.9453C20.6951 13.0058 20.7417 13.2639 20.5735 13.3867C19.7466 13.9902 19.1386 14.4226 18.7395 14.6621L17.9153 15.1562L20.6008 17.8418C20.9772 18.2184 20.9774 18.8335 20.6008 19.21H20.5999L19.1438 20.666C18.9567 20.8534 18.7104 20.9481 18.4602 20.9482H18.4592C18.2103 20.9486 17.9623 20.8543 17.7737 20.666L15.7698 18.6611L15.0911 17.9824L14.5969 18.8057C14.3463 19.2233 13.9125 19.8399 13.2756 20.7119C13.1579 20.8727 12.9354 20.8264 12.8801 20.6533C11.822 17.3426 9.99749 11.3616 9.46704 9.5332Z"
        stroke="#899CBD"
        strokeWidth="1.5"
      />
      <path
        d="M10 5V2M13.5 6.5L16 4M6.5 13.5L4.5 15.5M5 10H2M6.5 6.5L4.5 4.5"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TrafficIcon